import { render, staticRenderFns } from "./GestionDeUsuarios.vue?vue&type=template&id=52edc1ad&"
import script from "./GestionDeUsuarios.vue?vue&type=script&lang=js&"
export * from "./GestionDeUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports